import template from './productsSelector.html';
import controller from './productsSelector.controller';
import metaData from '../../models/metaData.js';

let productsSelectorComponent = () => {
  return {
    restrict: 'E',
    require: '^^entitler',
    scope: {},
    template,
    controller,
    controllerAs: 'vm',
    link: ($scope, $elem, $attrs, entitler) => {
      setDefaults($scope, entitler);
      $scope.vm.reloadProductSelections(entitler);
    }
  };
};

function setDefaults($scope, entitler) {
  $scope.vm.metaData = {};
  angular.copy(metaData, $scope.vm.metaData);

  $scope.vm.entitler = entitler;
  $scope.vm.metaData.entitler.dataSet = entitler;
  $scope.vm.metaData.entitler.search.value = $scope.vm.searchValue;
}

export
default productsSelectorComponent;


// WEBPACK FOOTER //
// ./app/components/productsSelector/productsSelector.component.js